export default "__VITE_ASSET__BnuCXE_U__"